import { IHideRecommendationParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class UndoHideRecommendationRequest extends Request<IHideRecommendationParams, IResult> {
  constructor(params: IHideRecommendationParams) {
    super('unhideRecommendation', params);
  }
}
